(() => {
  const roots = document.querySelectorAll('[data-rf-microhead]');

  roots.forEach((root) => {
    if (root.dataset.rfInit === 'true') return;
    root.dataset.rfInit = 'true';

    const toggle = root.querySelector('[data-rf-menu-toggle]');
    const closeBtn = root.querySelector('[data-rf-menu-close]');
    const drawer = root.querySelector('[data-rf-menu]');
    const backdrop = root.querySelector('[data-rf-menu-backdrop]');

    if (!toggle || !drawer || !backdrop) return;

    const openMenu = () => {
      toggle.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');

      drawer.hidden = false;
      backdrop.hidden = false;

      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
      });

      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('rf-microhead-lock');
      document.body.classList.add('rf-microhead-lock');
    };

    const closeMenu = () => {
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      backdrop.hidden = true;
      document.documentElement.classList.remove('rf-microhead-lock');
      document.body.classList.remove('rf-microhead-lock');

      setTimeout(() => {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
        }
      }, 320);
    };

    toggle.addEventListener('click', () => {
      if (drawer.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    backdrop.addEventListener('click', closeMenu);

    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeMenu();
      }
    });
  });
})();